// removed by extract-text-webpack-plugin
module.exports = {"bottomNavContainerHidden":"bottomNavContainerHidden__2NwV1","bottomNavContainerVisible":"bottomNavContainerVisible__1qjv6","tabWrapper":"tabWrapper__1U_vO","tab":"tab__37tjd","highlightText":"highlightText__2krDY","activeTab":"activeTab__pxiqR"};


//////////////////
// WEBPACK FOOTER
// ./components/partial/container/bicRevampContainer/bottomNav/style.css
// module id = akV1
// module chunks = 380